// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46747ac8","453":"48ac800c","455":"6e700f1e","977":"b289c8a2"}[chunkId] + ".chunk.js";
};